module.exports = __webpack_public_path__ + "img/alp01.c30a4382.png";